import type { ListBuilderList } from '../../../types';

/**
 * My Requests list configuration
 * Shows requests assigned to the current user.
 *
 * Default sort puts SRs with `pending_info` lines at the very top —
 * those are the rows blocked on the requestor (this user) for
 * clarification, and they're easy to lose in a long list otherwise.
 * Secondary keys: priority DESC, target_date ASC, so the urgent
 * stuff with the closest deadline floats up next.
 *
 * See `SOURCING_REQUEST_LIST_CONFIG.tableSorts['awaiting-info-first']`
 * for the exact field order.
 */
export const myRequestsList: ListBuilderList = {
	id: 'default-sourcing-requests-my-requests',
	cacheTTL: 300000,
	name: 'My Requests',
	type: 'default',
	active: true,
	sortOrder: 1,
	defaultSortId: 'awaiting-info-first',
	filterRules: {
		sourcingRequestAssignedUser: {
			defaultValue: [{ id: 'ME', label: 'Me' }],
			locked: true,
			hidden: true,
		},
	},
	inheritsFrom: 'default-sourcing-requests-all',
};
